import { UpdateCacheSettingDto, UserCacheControl } from "@model/cache/UserCacheControl"
import { ApiService, HttpMethod } from "@service/ApiService"
import { CacheService } from "@service/cache/CacheService"
export class MainCacheService implements CacheService {
    constructor(private apiService: ApiService) {}

    async fetchUserCache(sessionId: string): Promise<UserCacheControl> {
        const response = await this.apiService.makeRequest({
            method: HttpMethod.Get,
            path: "/core-api/UserCacheControl/GetUserCacheControl",
            query: { sessionId: sessionId },
        })
        if (response.isError() || !ApiService.isValidObjectResponse(response)) {
            return Promise.reject(new Error("Error fetching user cache"))
        }

        return mapToUserCacheControl(response.value)
    }

    async updateUserCache(sessionId: string, data: UpdateCacheSettingDto[]): Promise<void> {
        const response = await this.apiService.makeRequest({
            method: HttpMethod.Put,
            path: "/core-api/UserCacheControl/UpdateCacheSettings",
            query: { sessionId: sessionId },
            body: data,
        })
        if (response.isError() || !ApiService.isValidObjectResponse(response)) {
            return Promise.reject(new Error("Error updating user cache"))
        }
        return Promise.resolve()
    }
}

function mapToUserCacheControl(obj: any): UserCacheControl {
    return {
        sessionID: obj.sessionID ?? "",
        userId: obj.userId ?? 0,
        companyId: obj.companyId ?? 0,
        parentCompanyId: obj.parentCompanyId,
        cacheSettingsString: obj.cacheSettingsString ?? null,
        createdDateTime: obj.createdDateTime ? new Date(obj.createdDateTime) : new Date(),
        lastUpdateDateTime: obj.lastUpdateDateTime ? new Date(obj.lastUpdateDateTime) : undefined,
        cacheSettings: obj.cacheSettings ?? null, // Added required property
    }
}
